import {Backdrop} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles, ThemeProvider} from '@material-ui/core/styles';
import axios from 'axios';
import {createBrowserHistory} from 'history';
import {SnackbarProvider} from 'notistack';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Route, Router, Switch} from 'react-router-dom';
import {AppContextProvider} from './components/shared/context';
import theme from './components/theme';
import indexRoutes from './routes/layouts/index';
import publicRoutes from './routes/layouts/public';
import Ok from './images/icons/ok.svg'
import Important from './images/icons/important.svg'
import Info from './images/icons/info.svg'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import rolesRoutes from "./routes/layouts/roles";


const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: '#68fcb0',
    boxShadow: 'none',
    color: '#061243',
    width: '400px',
    height: '48px',
    fontFamily: 'IBM Plex Sans',
    fontSize: '16px',
  },
  error: {
    backgroundColor: '#ff93b3',
    boxShadow: 'none',
    color: '#061243',
    width: '400px',
    height: '48px',
    fontFamily: 'IBM Plex Sans',
    fontSize: '16px',
  },
  info: {
    backgroundColor: '#90b8ff',
    boxShadow: 'none',
    color: '#061243',
    width: '400px',
    height: '48px',
    fontFamily: 'IBM Plex Sans',
    fontSize: '16px',
  },
}));
const hist = createBrowserHistory();

function App(props) {
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  // Interceptios register

  axios.interceptors.request.use((config) => {
    setLoading(true);
    return config
  });

  axios.interceptors.response.use((response) => {
    setLoading(false);
    return response;
  }, (error) => {
    // alert('Ocorreu um erro ao processar sua requisição!')

    // if (error.response.status === 401 || error.response.status === 403) {
    //   window.location = '/';
    // } else {
    //   return Promise.reject(error);
    // }
  });

  const { keycloak, possuiAcesso, roles, role, selecionarPerfil, roleSelecionada } = props;

  let rotas;
  if (possuiAcesso && selecionarPerfil) {
    rotas = rolesRoutes;
  } else if (possuiAcesso) {
    rotas = indexRoutes;
  } else {
    rotas = publicRoutes;
  }

  const notistackRef = React.createRef();
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key);
  }

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Backdrop style={{ zIndex: '1101' }} open={isLoading}>
          <CircularProgress />
        </Backdrop>
        <AppContextProvider roles={roles} role={role} keycloak={keycloak} roleSelecionada={roleSelecionada} >
          <SnackbarProvider
            ref={notistackRef}
            action={(key) => (
              <CancelOutlinedIcon onClick={onClickDismiss(key)} />
            )}
            maxSnack={1}
            classes={{
              variantSuccess: classes.success,
              variantError: classes.error,
              variantInfo: classes.info,
            }}
            iconVariant={{
              success: <img src={Ok} style={{ marginRight: '16px' }} />,
              error: <img src={Important} style={{ marginRight: '16px' }}  />,
              info: <img src={Info} style={{ marginRight: '16px' }} />,
            }}>
            <Router history={hist}>
              <Switch>
                {rotas.map((prop, key) => <Route path={prop.path} key={key} component={prop.component} />)}
              </Switch>
            </Router>
          </SnackbarProvider>
        </AppContextProvider>
      </ThemeProvider>
    </div>

  );
}

export default App;

App.propTypes = {
  keycloak: PropTypes.shape({}).isRequired,
};
